import { RunnerTimer } from "./RunnerTimer";
import type { PresentationTaskRunner } from "@slot/presentation";

export const DEFAULT_IDLE_HINT_DELAY_SECONDS = 8;

/**
 * The "hold to spin" hint: shown `delaySeconds` after the last activity while a spin is possible and
 * nothing is pressed; hidden by any activity. `canShow` is the presenter's view of that condition.
 */
export class IdleHintPolicy {
  private readonly timer: RunnerTimer;

  public constructor(
    private readonly deps: {
      runner: PresentationTaskRunner;
      enabled: boolean;
      delaySeconds?: number;
      canShow(): boolean;
      setVisible(visible: boolean): void;
    },
  ) {
    this.timer = new RunnerTimer(deps.runner, "spin_input");
  }

  /** Activity while a spin is possible: hide now, show again after the delay (if still possible). */
  public arm(): void {
    this.hide();
    if (!this.deps.enabled) return;
    this.timer.schedule(this.deps.delaySeconds ?? DEFAULT_IDLE_HINT_DELAY_SECONDS, () => this.deps.setVisible(this.deps.canShow()));
  }

  public hide(): void {
    this.timer.cancel();
    this.deps.setVisible(false);
  }

  /** Re-evaluate without touching the timer (a coordinator change while nothing is held). */
  public refresh(): void {
    this.deps.setVisible(this.deps.enabled && !this.timer.isPending && this.deps.canShow());
  }

  public stop(): void {
    this.hide();
  }
}
